import * as React from "react";
const SvgSimulationLive24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 20,
        fill: "black",
        viewBox: "0 0 22 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6 10c0 1.736.884 3.264 2.226 4.16l-1.11 1.665A6.993 6.993 0 0 1 4 10c0-2.43 1.238-4.57 3.117-5.825l1.11 1.665A4.995 4.995 0 0 0 6 10Zm8.883 5.825-1.11-1.664A4.995 4.995 0 0 0 16 10a4.995 4.995 0 0 0-2.226-4.161l1.11-1.665A6.993 6.993 0 0 1 18 10c0 2.43-1.238 4.57-3.117 5.825ZM20 10a8.991 8.991 0 0 0-4.007-7.489l1.11-1.664A10.99 10.99 0 0 1 22 10a10.99 10.99 0 0 1-4.898 9.154l-1.11-1.665A8.991 8.991 0 0 0 20 10ZM0 10A10.99 10.99 0 0 1 4.898.847l1.11 1.664A8.991 8.991 0 0 0 2 10.001a8.991 8.991 0 0 0 4.007 7.488l-1.11 1.665A10.99 10.99 0 0 1 0 10Zm11 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
      clipRule: "evenodd"
    })
  );
export default SvgSimulationLive24Px;
